import DateFormat from "../common/dateFormat/DateFormat";
import cookie from 'react-cookies'

const INITIAL_STATE = {
	registro: {},
	modoTela: 'lista',
	aguardando: false,
	lista: [],
	filtro: {
		dataInicial: DateFormat.getDataAnterior(60),
		dataFinal: DateFormat.getDataAtual(),
		idFornecedor: null,
		idCliente: null,
		situacoes: cookie.load('cookieSituacoes') || ['aberto', 'backorder'],
		pesquisa: ''
	},
	listaSolicitacaoAberta: [],
	listaItens: [],
	listaHistoricos: [],
	listaCotacoes: [],
	listaFreteTipoSelect: [],
	listaProdutoHistorico: []
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
		case 'PEDIDO_MODO_TELA':
            return { ...state,
				modoTela: action.payload.modo,
				registro: action.payload.registro
			};

		case 'PEDIDO_SET_AGUARDANDO':
			return { ...state,
				aguardando: action.payload
			};
			
		case 'PEDIDO_SET_FILTRO':
			return { ...state,
				filtro: action.payload
			};

        case 'PEDIDO_LISTADO':
            return {
				...state,
				lista: action.payload.data
			};
		
		case 'PEDIDO_SOLICITACAO_COMPRA_ABERTA_LISTADO':
			return {
				...state,
				listaSolicitacaoAberta: action.payload.data
			}
		
		case 'PEDIDO_ITEM_LISTADO':
            return {
				...state,
				listaItens: action.payload.data
			};

		case 'PEDIDO_HISTORICO_LISTADO':
            return {
				...state,
				listaHistoricos: action.payload.data
			};
			
		case 'PEDIDO_COTACAO_LISTADO':
            return {
				...state,
				listaCotacoes: action.payload.data
			};
		
		case 'PEDIDO_FRETE_TIPO_SELECT_LISTADO':
			return {
				...state,
				listaFreteTipoSelect: action.payload.data
			};
		
		case 'PEDIDO_PRODUTO_HISTORICO_LISTADO':
			return {
				...state,
				listaProdutoHistorico: action.payload.data
			};
			
        default:
            return state;
    }
}
